import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const TidalDoc = (props) => { 
    return (
        <div>
          <p>
            The input box lets you enter tidal-expressions to execute. These expressions create nested-patterns within the triggers that the effect receives. These nested-patterns will trigger for the duration of the trigger.  For example, a trigger of duration=16 (i.e. 1 bar), when run through a tidal effect, will output a pattern playing for 1 bar.
            
          </p>
          <p className="sub-header">
            Tidal Expressions
          </p>
          <p>
            Tidal-expressions divide a cycle into sub-patterns. For example, <code>[0 12 0 12]</code>, divides the cycle into 4 parts. 
          </p>
          <p>
            The numbers within this expression refer to transposes that get added to the inputted triggers. For example, if the inputed trigger has transpose=12, then the outputted triggers will be 12, 24, 12, and then 24.
          </p>
          <p>
            The <code>~</code> expression is a "rest", meaning the sequencer won't play on that part.
          </p>
          <p className="sub-header">
            Nested-Expressions
          </p>
          <p>
            You can write nested-expressions like <code>[0 [12 24] 0 0]</code>. In this example,
            the second beat will be divided into 2 equal parts (triggering 12 and then 24). 
          </p>
          <p>
            Now, if you change the nested-pattern to have 3 parts, like <code>[0 [12 24 12] 0 0]</code>, then the second beat will play <b>triplets</b>. That's because we divided the second beat into 3 parts, hence a <b>triplet</b>.
          </p>
          <p>
            If you wanted the entire beat to be a triplet, reduce the number of parts in your top-level expression to 3. For example, <code>[0 5 10]</code> will give you a triplet over the course of one bar.
          </p>
          <p className="sub-header">
            Cycle Length
          </p>
          <p>
            The <b>Cycle Length</b> parameter controls how many 1/32th steps it takes for tidal to complete 1 cycle. By default, it is set 32 steps, which is 1 bar. However you can change it to any number from 4-64, each of which still works as a rhythm. 
          </p>
          <p>
            Changing the <b>Cycle Length</b> is similar in effect to changing the time-signature of the pattern. Try gently increasing the <b>Cycle Length</b> to add some subtle swing.
          </p>
          <p>
            <b>Tip</b>: If you have an interesting rhythm going, simply change the <b>Cycle Length</b> to give
            a variation of your rhythm that still follows the structure of your original pattern. Create a new pattern and lock the track, and change the cycle so you have an alternate pattern to switch against.
            
          </p>
          <p className="sub-header">
            Operations
          </p>
          <p>
            Tidal includes some basic operations to keep expression short. The main operator you should know is the <code>*</code> operator.
            <p>
              The expression <code>[1*6]</code> is equivalent to <code>[1 1 1 1 1 1]</code>. You can do this within sub-patterns, for example <code>[0 [0*3 2*3] 0 0]</code> is equivalent to <code>[0 [0 0 0 2 2 2] 0 0]</code>
            </p>
          </p>
          <p className="sub-header">
            Variables
          </p>
          <p>
            You can add variables to your tidal-expressions, which will create a slider below that controls these variables. For example, the expression <code>[a 0 0 0]</code> will create a slider that lets you control the <code>a</code> variable.
          </p>
          <p>
            These variables work in operations as well. For example <code>[0*a 0]</code> gives you a slider that lets you control how many times the first part will repeat.
          </p>
          <p>
            The sliders that control these variables can be modulated and mapped to other MIDI effects, allowing you to control them in a number of ways. 
          </p>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TidalDoc);
